import styled from 'styled-components';

//engagement main page
const Headerbody = styled.section`
	// common for table UI start

	.userlistwrapper {
		display: inline-grid;
		width: 100%;

		.contentHistoryPlaceHolderText {
			border: var(--px-1) solid var(--neutrals-200);
		}

		.manageaccessitemview {
			width: 100%;
			display: flex;
			border-collapse: collapse;
			align-items: center;
			justify-content: center;
			border-bottom: var(--px-1) solid var(--neutrals-200);
			border-radius: 0 0 var(--px-8) var(--px-8);
			&.inactive mgt-person {
				color: var(--neutrals-300);
			}

			&:not(.inactive) .userName {
				color: var(--neutrals-900);
			}

			.grid {
				display: grid;
				grid-template-columns: auto 1fr;
				grid-gap: 0 10px;
			}

			&:last-child {
				border-bottom: none !important;
			}
		}

		.userlist-header {
			width: 100%;
			display: inline-block;
			.userlistheader {
				width: 100%;
				color: var(--neutrals-700);
				font-weight: bold;
				display: flex;
				border-collapse: collapse;
				background: var(--neutrals-50);
				border: var(--px-1) solid var(--neutrals-200);
				height: var(--px-48);
				border-radius: var(--px-8) var(--px-8) 0 0;
				border-bottom: none;
			}
		}

		.userlist-body {
			overflow: auto;
			height: calc(100vh - var(--px-490));
			display: inline-block;
			width: 100%;
			border: var(--px-1) solid var(--neutrals-200);
			border-radius: 0 0 var(--px-8) var(--px-8);
			background: var(--neutrals-00white);
			.userlistholder {
				height: var(--px-48);
				display: block;
				align-items: center;
			}
		}

		.userlist-header,
		.userlist-body {
			.userlistitem {
				padding: 0 var(--spacing-large);
				flex: 1 1 auto;
				width: 15%;
				vertical-align: middle;
				display: flex;
				align-items: center;				
				height: var(--px-48);

				.description {
					display: flex;

					svg.delete {
						cursor: pointer;
					}
				}

				.ellipses {
					vertical-align: middle;
					line-height: normal;
				}
				&.status {
					width: 10%;
					.ellipses {
						vertical-align: middle;
						line-height: normal;
					}
				}

				&.attribute {
					width: 20%;
					.ellipses {
						vertical-align: middle;
						line-height: normal;
					}
				}

				&.date{
					width: 6%;

					.ellipses {
						vertical-align: middle;
						line-height: normal;
					}
				}

				.engname {
					width: 100%;
					display: inline-grid;

					.ellipses {
						font-size: var(--px-12);
						font-weight: 300;
						line-height: var(--px-18);
					}
				}
			}
		}
	}

	// common for table UI end
`;

export default Headerbody;
